(() => {
  const patchPlaceAutocompleteOpenShadow = () => {
    if (window.__storeLocatorShadowPatched) return;
    window.__storeLocatorShadowPatched = true;
    const nativeAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function attachShadow(init) {
      if (this.localName === 'gmp-place-autocomplete') {
        return nativeAttachShadow.call(this, { ...init, mode: 'open' });
      }
      return nativeAttachShadow.call(this, init);
    };
  };

  const restorePlaceAutocompleteInlineWidget = () => {
    document.querySelectorAll('gmp-place-autocomplete').forEach((autocomplete) => {
      const root = autocomplete.shadowRoot;
      if (!root) return;

      const dialog = root.querySelector('dialog.full-window-autocomplete-dialog');
      const widget = dialog?.querySelector(':scope > .widget-container');

      if (dialog && widget && widget.parentElement === dialog) {
        root.insertBefore(widget, dialog.nextSibling);
      }

      if (dialog?.open) dialog.close();

      root.querySelectorAll('.widget-container .input-container, .widget-container input').forEach((node) => {
        node.style.removeProperty('visibility');
        node.style.removeProperty('display');
        node.style.removeProperty('opacity');
      });
    });
  };

  const patchAutocompleteFullWindowDialog = () => {
    if (window.__storeLocatorAutocompleteDialogPatched) return;
    window.__storeLocatorAutocompleteDialogPatched = true;

    const interceptFullWindowAutocompleteDialog = (dialog) => {
      if (!dialog?.classList?.contains('full-window-autocomplete-dialog')) return false;
      restorePlaceAutocompleteInlineWidget();
      return true;
    };

    const nativeShow = HTMLDialogElement.prototype.show;
    HTMLDialogElement.prototype.show = function show(...args) {
      if (interceptFullWindowAutocompleteDialog(this)) return;
      return nativeShow.apply(this, args);
    };

    const nativeShowModal = HTMLDialogElement.prototype.showModal;
    HTMLDialogElement.prototype.showModal = function showModal(...args) {
      if (interceptFullWindowAutocompleteDialog(this)) return;
      return nativeShowModal.apply(this, args);
    };
  };

  patchPlaceAutocompleteOpenShadow();
  patchAutocompleteFullWindowDialog();

  const MSG_EMPTY_ADDRESS =
    'Aucune adresse renseignée, veuillez indiquer une adresse.';
  const MSG_NO_STORES_IN_AREA =
    "Aucun point de vente à proximité, veuillez essayer un autre emplacement";
  const MSG_GEOLOCATING = 'Localisation en cours…';
  const DEFAULT_MAP_CENTER = { lat: 48.8566, lng: 2.3522 };
  const DEFAULT_ADDRESS = 'Paris, IDF, FR';
  const DEFAULT_MAP_OVERVIEW_ZOOM = 6;
  const DEFAULT_DISTANCE_KM = 50;
  const LOCATION_PRIMARY_TYPES = ['locality', 'postal_code', 'country'];
  const PRECISE_ADDRESS_TYPES = new Set([
    'street_address',
    'premise',
    'subpremise',
    'route',
    'establishment',
    'point_of_interest',
    'floor',
    'room',
  ]);
  const FR_REGION_CODES = {
    'auvergne-rhone-alpes': 'ARA',
    'bourgogne-franche-comte': 'BFC',
    'bretagne': 'BRE',
    'centre-val de loire': 'CVL',
    'corse': 'COR',
    'grand est': 'GES',
    'hauts-de-france': 'HDF',
    'ile-de-france': 'IDF',
    'normandie': 'NOR',
    'nouvelle-aquitaine': 'NAQ',
    'occitanie': 'OCC',
    'pays de la loire': 'PDL',
    'provence-alpes-cote d azur': 'PAC',
    'guadeloupe': 'GP',
    'guyane': 'GF',
    'la reunion': 'RE',
    'martinique': 'MQ',
    'mayotte': 'YT',
  };
  const MARKER_Z_INDEX = {
    homeBehind: 80,
    home: 120,
    poi: 20,
    poiActive: 150,
    popup: 200,
  };
  const USER_MARKER_COMPACT_SCALE = 0.6;
  const MAP_FLY_DURATION_MS = 650;
  const toRad = (v) => (v * Math.PI) / 180;
  const distanceKm = (a, b) => {
    const r = 6371;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const aa =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return r * 2 * Math.atan2(Math.sqrt(aa), Math.sqrt(1 - aa));
  };

  const normalizeRegionKey = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/['’]/g, ' ')
      .replace(/\s+/g, ' ');

  const getComponentField = (component, field = 'long') => {
    if (!component) return '';
    if (field === 'short') return String(component.shortText || component.short_name || '').trim();
    return String(component.longText || component.long_name || '').trim();
  };

  const getAddressComponent = (components, type) =>
    (components || []).find((component) => component.types?.includes(type));

  const getRegionCodeFromComponent = (component) => {
    if (!component) return '';
    const short = getComponentField(component, 'short');
    if (/^FR-/i.test(short)) return short.split('-')[1].toUpperCase();
    if (short && short.length <= 4 && short === short.toUpperCase()) return short;
    return FR_REGION_CODES[normalizeRegionKey(getComponentField(component, 'long'))] || short.toUpperCase();
  };

  const formatLocationLabelFromComponents = (components) => {
    if (!components?.length) return '';

    const locality =
      getAddressComponent(components, 'locality') ||
      getAddressComponent(components, 'postal_town') ||
      getAddressComponent(components, 'administrative_area_level_2');
    const postal = getAddressComponent(components, 'postal_code');
    const admin1 = getAddressComponent(components, 'administrative_area_level_1');
    const country = getAddressComponent(components, 'country');

    let cityPart = getComponentField(locality, 'long') || getComponentField(postal, 'long');
    if (!cityPart && country && !locality && !postal) {
      cityPart = getComponentField(country, 'long');
    }

    const regionCode = getRegionCodeFromComponent(admin1);
    const countryCode = getComponentField(country, 'short').toUpperCase();

    return [cityPart, regionCode, countryCode].filter(Boolean).join(', ');
  };

  const formatLocationLabelFromGeocoderResult = (result) =>
    formatLocationLabelFromComponents(result?.address_components || []);

  const isPreciseAddressResult = (result) => {
    const types = result?.types || [];
    if (types.some((type) => PRECISE_ADDRESS_TYPES.has(type))) return true;
    return (result?.address_components || []).some((component) =>
      component.types?.some((type) => PRECISE_ADDRESS_TYPES.has(type))
    );
  };

  const extractCountryFromSecondaryText = (value) => {
    const base = String(value || '')
      .replace(/\b\d{5}\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!base) return '';

    const parts = base
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean);

    return parts.length ? parts[parts.length - 1] : base;
  };

  const parseRegionCountryFromSecondaryText = (value) => {
    const base = String(value || '')
      .replace(/\b\d{5}\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!base) return { region: '', country: '' };

    const parts = base
      .split(',')
      .map((part) => part.trim())
      .filter(Boolean);

    if (!parts.length) return { region: '', country: '' };

    const country = parts[parts.length - 1];
    const region = parts.length > 1 ? parts[parts.length - 2] : '';

    return { region, country };
  };

  const formatRegionCountrySecondaryLabel = (region, country) =>
    [region, country].filter(Boolean).join(', ');

  const pickCityLevelGeocodeResult = (results) => {
    if (!results?.length) return null;

    const scored = results
      .filter((result) => !isPreciseAddressResult(result))
      .map((result) => {
        const types = result.types || [];
        const components = result.address_components || [];
        let score = 0;
        if (types.includes('locality') || components.some((c) => c.types?.includes('locality'))) score += 40;
        if (types.includes('postal_code') || components.some((c) => c.types?.includes('postal_code'))) score += 25;
        if (types.includes('country') || components.some((c) => c.types?.includes('country'))) score += 15;
        if (types.includes('administrative_area_level_1')) score += 5;
        return { result, score };
      })
      .sort((a, b) => b.score - a.score);

    return scored[0]?.result || null;
  };

  const CSV_COLUMN_ALIASES = {
    name: ['name', 'nom', 'poi_name', 'title', 'titre'],
    address: ['address', 'adresse', 'poi_address', 'adress'],
    business_profile: ['business_profile', 'fiche_google', 'google_business', 'opening_hours'],
    category: ['category', 'categorie', 'poi_category', 'type'],
    category_en: ['category_en', 'categorie_en'],
    category_bg: ['category_bg', 'poi_category_bg', 'bg', 'fond'],
    category_text: ['category_text', 'poi_category_text', 'text', 'texte'],
    lat: ['lat', 'latitude'],
    lng: ['lng', 'lon', 'long', 'longitude'],
  };

  const normalizeCsvHeader = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');

  const resolveCsvField = (row, field) => {
    const aliases = CSV_COLUMN_ALIASES[field] || [field];
    for (const alias of aliases) {
      if (Object.prototype.hasOwnProperty.call(row, alias)) return row[alias];
    }
    return '';
  };

  const parseCsvRows = (text) => {
    const rows = [];
    let row = [];
    let cell = '';
    let inQuotes = false;

    for (let i = 0; i < text.length; i += 1) {
      const char = text[i];
      const next = text[i + 1];

      if (char === '"') {
        if (inQuotes && next === '"') {
          cell += '"';
          i += 1;
        } else {
          inQuotes = !inQuotes;
        }
        continue;
      }

      if (!inQuotes && char === ',') {
        row.push(cell);
        cell = '';
        continue;
      }

      if (!inQuotes && (char === '\n' || char === '\r')) {
        if (char === '\r' && next === '\n') i += 1;
        row.push(cell);
        rows.push(row);
        row = [];
        cell = '';
        continue;
      }

      cell += char;
    }

    if (cell.length || row.length) {
      row.push(cell);
      rows.push(row);
    }

    const nonEmptyRows = rows.filter((cells) => cells.some((value) => String(value).trim()));
    if (!nonEmptyRows.length) return [];

    const headers = nonEmptyRows[0].map((header) => normalizeCsvHeader(header));
    return nonEmptyRows.slice(1).map((cells, index) => {
      const record = { __row: index + 2 };
      headers.forEach((header, headerIndex) => {
        if (!header) return;
        record[header] = String(cells[headerIndex] ?? '').trim();
      });
      return record;
    });
  };

  const parseCoordinate = (value) => {
    if (value === '' || value == null) return null;
    const parsed = Number(String(value).replace(',', '.').trim());
    return Number.isFinite(parsed) ? parsed : null;
  };

  const isEnglishLocale = () =>
    String(document.documentElement.lang || '')
      .trim()
      .toLowerCase()
      .startsWith('en');

  const csvRowToPoint = (row, index) => {
    const address = String(resolveCsvField(row, 'address') || '').trim();
    if (!address) return null;

    const category = String(resolveCsvField(row, 'category') || '').trim();
    const categoryEn = String(resolveCsvField(row, 'category_en') || '').trim();

    return {
      id: `csv-${index + 1}`,
      name: String(resolveCsvField(row, 'name') || address).trim(),
      address,
      business_profile: String(resolveCsvField(row, 'business_profile') || '').trim(),
      category: isEnglishLocale() && categoryEn ? categoryEn : category,
      category_bg: String(resolveCsvField(row, 'category_bg') || 'white-105').trim(),
      category_text: String(resolveCsvField(row, 'category_text') || 'black-90').trim(),
      lat: parseCoordinate(resolveCsvField(row, 'lat')),
      lng: parseCoordinate(resolveCsvField(row, 'lng')),
    };
  };

  const parseGoogleSpreadsheetInput = (input) => {
    const trimmed = String(input || '').trim();
    if (!trimmed) return null;

    const gidMatch = trimmed.match(/(?:[?&#]gid=)([0-9]+)/);
    const gid = gidMatch?.[1] || '0';

    if (/output=csv|\/pub(?:\?|\/)/i.test(trimmed)) {
      return { fetchUrl: trimmed.split('#')[0], gid };
    }

    const publishedIdMatch = trimmed.match(/\/spreadsheets\/d\/e\/([^/]+)/);
    if (publishedIdMatch) {
      return {
        id: publishedIdMatch[1],
        gid,
        fetchUrl: `https://docs.google.com/spreadsheets/d/e/${publishedIdMatch[1]}/pub?output=csv&gid=${encodeURIComponent(gid)}`,
      };
    }

    const idMatch = trimmed.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
    const spreadsheetId = idMatch?.[1];
    if (!spreadsheetId || spreadsheetId === 'e') return null;

    return {
      id: spreadsheetId,
      gid,
    };
  };

  const buildGoogleSheetsCsvUrl = ({ id, gid }) =>
    `https://docs.google.com/spreadsheets/d/${id}/gviz/tq?tqx=out:csv&gid=${encodeURIComponent(gid)}`;

  const withCacheBust = (url) => `${url}${url.includes('?') ? '&' : '?'}t=${Date.now()}`;

  const isGoogleSheetsLoginResponse = (url, body) =>
    /accounts\.google\.com|ServiceLogin/i.test(String(url || '')) || /^\s*</.test(String(body || '').slice(0, 200));

  const fetchGoogleSheetCsvText = async (url) => {
    const response = await fetch(url, { redirect: 'follow' });
    const finalUrl = response.url || url;
    const body = await response.text();

    if (isGoogleSheetsLoginResponse(finalUrl, body)) {
      throw new Error('SHEETS_NOT_PUBLIC');
    }
    if (!response.ok) {
      throw new Error(`Sheets fetch failed (${response.status})`);
    }

    return body;
  };

  const gvizJsonToRows = (response) => {
    if (response?.status === 'error') {
      throw new Error(response.errors?.[0]?.message || 'Sheets gviz error');
    }

    const cols =
      response?.table?.cols?.map((col) => normalizeCsvHeader(col?.label || col?.id || '')) || [];
    return (response?.table?.rows || []).map((row, index) => {
      const record = { __row: index + 2 };
      (row.c || []).forEach((cell, colIndex) => {
        const header = cols[colIndex];
        if (!header) return;
        const value = cell?.v ?? cell?.f ?? '';
        record[header] = String(value ?? '').trim();
      });
      return record;
    });
  };

  const fetchGoogleSheetViaGvizJsonp = ({ id, gid }) =>
    new Promise((resolve, reject) => {
      const callbackName = `storeLocatorSheet_${Date.now()}_${Math.floor(Math.random() * 1e6)}`;
      let script;

      const cleanup = () => {
        delete window[callbackName];
        script?.remove();
      };

      const timeoutId = window.setTimeout(() => {
        cleanup();
        reject(new Error('Sheets JSONP timeout'));
      }, 15000);

      window[callbackName] = (response) => {
        window.clearTimeout(timeoutId);
        cleanup();
        try {
          resolve(gvizJsonToRows(response));
        } catch (error) {
          reject(error);
        }
      };

      script = document.createElement('script');
      script.src = `https://docs.google.com/spreadsheets/d/${encodeURIComponent(id)}/gviz/tq?gid=${encodeURIComponent(gid)}&tqx=${encodeURIComponent(`out:json;responseHandler:${callbackName}`)}&headers=1`;
      script.async = true;
      script.onerror = () => {
        window.clearTimeout(timeoutId);
        cleanup();
        reject(new Error('Sheets JSONP failed'));
      };
      document.head.appendChild(script);
    });

  let googleMapsLoaderPromise = null;

  const loadGoogleMapsApi = (apiKey) => {
    if (window.google?.maps?.importLibrary) {
      return Promise.resolve(window.google.maps);
    }

    if (!googleMapsLoaderPromise) {
      googleMapsLoaderPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&loading=async`;
        script.async = true;
        script.defer = true;
        script.onerror = () => reject(new Error('Google Maps failed to load'));
        script.onload = () => {
          if (window.google?.maps?.importLibrary) {
            resolve(window.google.maps);
            return;
          }
          reject(new Error('Google Maps failed to load'));
        };
        document.head.appendChild(script);
      });
    }

    return googleMapsLoaderPromise;
  };

  class StoreLocatorMap extends HTMLElement {
    connectedCallback() {
      this.apiKey = (this.dataset.googleMapsApiKey || '').trim();
      this.mapId = (this.dataset.googleMapsMapId || 'DEMO_MAP_ID').trim();
      this.closeIconUrl = (this.dataset.closeIconUrl || '').trim();
      this.localisationIconUrl = (this.dataset.localisationIconUrl || '').trim();
      this.clearIconMarkup = '';
      this.useGoogleSheets = this.dataset.pointsSource === 'sheets';
      this.googleSheetsUrl = (this.dataset.googleSheetsUrl || '').trim();
      this.mapNode = this.querySelector('[data-store-locator-map]');
      this.mapWrapper = this.querySelector('.store-locator__map-wrapper');
      this.layoutNode = this.querySelector('.store-locator__layout');
      this.listNode = this.querySelector('[data-store-locator-list]');
      this.statusNode = this.querySelector('[data-store-locator-status]');
      this.addressMount = this.querySelector('[data-store-locator-address-mount]');
      this.addressControl = this.addressMount?.closest('.address-control');
      this.distanceValueInput = this.querySelector('[data-store-locator-distance-value]');
      this.categoryValueInput = this.querySelector('[data-store-locator-category-value]');
      this.distanceLabel = this.querySelector('[data-store-locator-distance-label]');
      this.categoryLabel = this.querySelector('[data-store-locator-category-label]');
      this.distanceList = this.querySelector('[data-store-locator-distance-list]');
      this.categoryList = this.querySelector('[data-store-locator-category-list]');
      this.points = [];
      this.userPosition = null;
      this.filtered = [];
      this.markers = [];
      this.userMarker = null;
      this.userMarkerElement = null;
      this.poiPopupMarker = null;
      this.activeId = null;
      this.googleMapsWaitAttempts = 0;
      this.listReady = false;
      this.mapReady = false;
      this.geocodeRequestId = 0;
      this.allowedDistanceValues = new Set(['5', '10', '25', '50', '100']);
      this.pointsResolved = false;
      this.pointsResolvingPromise = null;
      this.geocoder = null;
      this.AdvancedMarkerElement = null;
      this.addressAutocomplete = null;
      this.hasCompleteAddress = false;
      this.confirmedAddressValue = '';
      this.lastConfirmedAddressAt = 0;
      this.suppressAddressInputClearReset = false;
      this.skipAddressChangeGeocode = false;
      this.autocompleteSuggestions = [];
      this.autocompleteSessionToken = null;
      this.autocompleteSyncTimer = null;
      this.autocompleteEnhanceTimer = null;
      this.countryLabelCache = new Map();
      this.countryLabelPending = new Map();
      this.mapFlyAnimationId = null;
      this.clearButtonVisibilityTimer = null;
      this.listMessages = this.loadListMessages();

      this.bindEvents();
      this.bootstrap();
    }

    loadListMessages() {
      const node = this.querySelector('[data-store-locator-messages]');
      let parsed = {};
      try {
        parsed = JSON.parse(node?.textContent || '{}');
      } catch (_error) {
        parsed = {};
      }

      return {
        emptyAddress: String(parsed.emptyAddress || '').trim() || MSG_EMPTY_ADDRESS,
        noStores: String(parsed.noStores || '').trim() || MSG_NO_STORES_IN_AREA,
      };
    }

    async bootstrap() {
      try {
        this.points = await this.loadPoints();
      } catch (error) {
        this.points = [];
        if (this.useGoogleSheets) {
          const isPrivate =
            error?.message === 'SHEETS_NOT_PUBLIC' ||
            /accounts\.google|ServiceLogin|JSONP/i.test(String(error?.message || ''));
          this.setStatus(
            isPrivate
              ? 'Google Sheets inaccessible : publiez la feuille sur le Web (Fichier > Partager > Publier sur le Web) ou partagez-la en lecture publique.'
              : 'Impossible de charger la liste Google Sheets. Verifiez l’URL et le partage de la feuille.'
          );
        }
      }

      this.populateCategories();
      this.userPosition = null;
      this.initMap();
    }

    normalizePoint(point) {
      return {
        ...point,
        lat: parseCoordinate(point.lat),
        lng: parseCoordinate(point.lng),
      };
    }

    loadManualPoints() {
      const rawPoints = JSON.parse(this.querySelector('[data-store-locator-points]')?.textContent || '[]');
      return rawPoints
        .map((point) => this.normalizePoint(point))
        .filter((point) => (point.address || '').trim());
    }

    async loadPointsFromGoogleSheets() {
      const spreadsheet = parseGoogleSpreadsheetInput(this.googleSheetsUrl);
      if (!spreadsheet) {
        throw new Error('Missing Google Sheets URL');
      }

      let rows;

      if (spreadsheet.fetchUrl) {
        const csvText = await fetchGoogleSheetCsvText(withCacheBust(spreadsheet.fetchUrl));
        rows = parseCsvRows(csvText);
      } else {
        try {
          rows = await fetchGoogleSheetViaGvizJsonp(spreadsheet);
        } catch (_jsonpError) {
          const csvText = await fetchGoogleSheetCsvText(withCacheBust(buildGoogleSheetsCsvUrl(spreadsheet)));
          rows = parseCsvRows(csvText);
        }
      }

      return rows
        .map((row, index) => csvRowToPoint(row, index))
        .filter(Boolean)
        .map((point) => this.normalizePoint(point));
    }

    async loadPoints() {
      if (this.useGoogleSheets) return this.loadPointsFromGoogleSheets();
      return this.loadManualPoints();
    }

    populateCategories() {
      const categories = [...new Set(this.points.map((p) => (p.category || '').trim()).filter(Boolean))];
      categories.forEach((cat) => {
        const item = document.createElement('li');
        item.innerHTML = `<button type="button" class="store-locator__dropdown-option ui-dropdown__option" role="option" data-value="${this.escapeHtml(cat)}">${this.escapeHtml(cat)}</button>`;
        this.categoryList?.appendChild(item);
      });
    }

    bindEvents() {
      this.setupDropdown({
        triggerSelector: '[data-store-locator-distance-trigger]',
        listSelector: '[data-store-locator-distance-list]',
        valueInput: this.distanceValueInput,
        labelNode: this.distanceLabel,
        onChange: () => this.applyFilters(),
        isSelectable: (optionButton) => this.allowedDistanceValues.has(optionButton.dataset.value ?? ''),
      });
      this.setupDropdown({
        triggerSelector: '[data-store-locator-category-trigger]',
        listSelector: '[data-store-locator-category-list]',
        valueInput: this.categoryValueInput,
        labelNode: this.categoryLabel,
        onChange: () => this.applyFilters(),
        keepInitialLabelWhenEmpty: true,
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) return;
        this.querySelectorAll('[data-store-locator-dropdown].is-open').forEach((dropdown) => {
          if (!dropdown.contains(event.target)) this.closeDropdown(dropdown);
        });
      });
      document.addEventListener('click', (event) => {
        if (this.contains(event.target)) return;
        this.querySelectorAll('[data-store-locator-dropdown].is-open').forEach((dropdown) => this.closeDropdown(dropdown));
      });
    }

    bindMapFullscreenHandling() {
      if (this.mapFullscreenBound) return;
      this.mapFullscreenBound = true;

      document.addEventListener('fullscreenchange', () => {
        if (!this.map) return;
        window.requestAnimationFrame(() => {
          google.maps.event.trigger(this.map, 'resize');
          this.scheduleMapViewSync();
        });
      });
    }

    async initMap() {
      if (!this.apiKey || !this.mapNode) {
        this.mapReady = true;
        this.commitReadyState();
        if (this.statusNode && !this.apiKey) {
          this.statusNode.textContent =
            'Ajoutez votre clé Google Maps dans snippets/store-locator-token.liquid.';
        }
        return;
      }

      try {
        const mapsApi = await loadGoogleMapsApi(this.apiKey);
        const [{ Map }, { ControlPosition }] = await Promise.all([
          mapsApi.importLibrary('maps'),
          mapsApi.importLibrary('core'),
        ]);
        const { AdvancedMarkerElement } = await mapsApi.importLibrary('marker');

        this.AdvancedMarkerElement = AdvancedMarkerElement;
        try {
          const { Geocoder } = await mapsApi.importLibrary('geocoding');
          this.geocoder = new Geocoder();
        } catch (_geocoderError) {
          this.geocoder = new google.maps.Geocoder();
        }

        this.map = new Map(this.mapNode, {
          mapId: this.mapId,
          center: DEFAULT_MAP_CENTER,
          zoom: DEFAULT_MAP_OVERVIEW_ZOOM,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: ControlPosition.INLINE_END_BLOCK_START,
          },
          cameraControl: true,
          rotateControl: true,
          zoomControl: true,
          clickableIcons: false,
        });

        this.bindMapFullscreenHandling();

        this.map.addListener('click', () => {
          if (!this.activeId) return;
          this.closePoiPopup();
        });

        await this.initAddressAutocomplete();

        this.mapReady = true;
        await this.resolvePointCoordinates();
        await this.initializeUserPosition();
        this.commitReadyState();
        this.scheduleMapViewSync();
      } catch (_error) {
        this.googleMapsWaitAttempts += 1;
        if (this.googleMapsWaitAttempts < 30) {
          googleMapsLoaderPromise = null;
          window.setTimeout(() => this.initMap(), 100);
          return;
        }
        this.mapReady = true;
        this.commitReadyState();
        this.setStatus('Impossible de charger Google Maps.');
      }
    }

    getBrowserGeolocation(options = {}) {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(Object.assign(new Error('GEOLOCATION_UNAVAILABLE'), { code: 2 }));
          return;
        }

        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
          ...options,
        });
      });
    }

    async getBrowserGeolocationWithFallback() {
      try {
        return await this.getBrowserGeolocation({
          enableHighAccuracy: true,
          timeout: 12000,
          maximumAge: 0,
        });
      } catch (_highAccuracyError) {
        return this.getBrowserGeolocation({
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 60000,
        });
      }
    }

    async geolocateViaGoogleApi() {
      if (!this.apiKey) return null;

      try {
        const response = await fetch(
          `https://www.googleapis.com/geolocation/v1/geolocate?key=${encodeURIComponent(this.apiKey)}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: '{}',
          }
        );
        const data = await response.json();
        if (!response.ok) return null;

        const lat = Number(data?.location?.lat);
        const lng = Number(data?.location?.lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

        return { lat, lng };
      } catch (_error) {
        return null;
      }
    }

    async getUserCoordinates() {
      try {
        const position = await this.getBrowserGeolocationWithFallback();
        return {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      } catch (_browserError) {
        const fromGoogleApi = await this.geolocateViaGoogleApi();
        if (fromGoogleApi) return fromGoogleApi;
        throw _browserError;
      }
    }

    async reverseGeocodeToLocationLabel(coords) {
      if (!this.geocoder || !coords) return null;

      return new Promise((resolve) => {
        const location =
          typeof google !== 'undefined' && google.maps?.LatLng
            ? new google.maps.LatLng(coords.lat, coords.lng)
            : coords;

        this.geocoder.geocode(
          {
            location,
            language: 'fr',
            region: 'fr',
          },
          (results, status) => {
            if (status !== 'OK' || !results?.length) {
              resolve(null);
              return;
            }
            const best = pickCityLevelGeocodeResult(results);
            resolve(best ? formatLocationLabelFromGeocoderResult(best) : null);
          }
        );
      });
    }

    parseGeocodeLocationResult(results) {
      const best = pickCityLevelGeocodeResult(results);
      if (!best?.geometry?.location) return null;

      const location = best.geometry.location;
      const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
      const lng = typeof location.lng === 'function' ? location.lng() : location.lng;
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

      return {
        lat,
        lng,
        label: formatLocationLabelFromGeocoderResult(best),
      };
    }

    async geocodeLocationQuery(query) {
      if (!query || !this.apiKey) return null;

      if (this.geocoder) {
        const fromClient = await new Promise((resolve) => {
          this.geocoder.geocode(
            {
              address: query,
              language: 'fr',
            },
            (results, status) => {
              resolve(status === 'OK' ? this.parseGeocodeLocationResult(results) : null);
            }
          );
        });
        if (fromClient) return fromClient;
      }

      try {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=${encodeURIComponent(this.apiKey)}&language=fr`;
        const response = await fetch(url);
        const data = await response.json();
        return this.parseGeocodeLocationResult(data?.results || []);
      } catch (_error) {
        return null;
      }
    }

    setAutocompleteLocationValue(label) {
      if (!label || !this.addressAutocomplete) return;
      const confirmedLabel = String(label).trim();
      this.skipAddressChangeGeocode = true;
      this.suppressAddressInputClearReset = true;
      this.confirmedAddressValue = confirmedLabel;
      this.hasCompleteAddress = true;
      this.lastConfirmedAddressAt = Date.now();
      this.addressAutocomplete.value = confirmedLabel;
      this.scheduleClearButtonVisibilitySync();
      window.requestAnimationFrame(() => {
        this.suppressAddressInputClearReset = false;
        this.scheduleClearButtonVisibilitySync();
      });
    }

    scheduleClearButtonVisibilitySync() {
      this.syncClearButtonVisibility();
      window.requestAnimationFrame(() => this.syncClearButtonVisibility());
      window.clearTimeout(this.clearButtonVisibilityTimer);
      this.clearButtonVisibilityTimer = window.setTimeout(() => {
        this.syncClearButtonVisibility();
      }, 120);
    }

    async initializeUserPosition() {
      this.setStatus(MSG_GEOLOCATING);

      try {
        const coords = await this.getUserCoordinates();

        if (!Number.isFinite(coords.lat) || !Number.isFinite(coords.lng)) {
          throw Object.assign(new Error('INVALID_COORDS'), { code: 2 });
        }

        await this.setUserPosition(coords, 10);
        this.setStatus('');

        const address = await this.reverseGeocodeToLocationLabel(coords);
        if (address) this.setAutocompleteLocationValue(address);
        else this.scheduleClearButtonVisibilitySync();
      } catch (_error) {
        await this.setDefaultParisLocation();
      }
    }

    async setDefaultParisLocation() {
      await this.setUserPosition({ ...DEFAULT_MAP_CENTER }, 10);
      this.setStatus('');

      this.setAutocompleteLocationValue(DEFAULT_ADDRESS);
    }

    async geocodeAddress(query) {
      if (!query || !this.apiKey) return null;

      if (this.geocoder) {
        const fromClient = await new Promise((resolve) => {
          this.geocoder.geocode(
            {
              address: query,
              region: 'FR',
              language: 'fr',
            },
            (results, status) => {
              if (status !== 'OK' || !results?.[0]?.geometry?.location) {
                resolve(null);
                return;
              }
              const location = results[0].geometry.location;
              resolve({
                lat: location.lat(),
                lng: location.lng(),
              });
            }
          );
        });
        if (fromClient) return fromClient;
      }

      try {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=${encodeURIComponent(this.apiKey)}&language=fr&region=fr`;
        const response = await fetch(url);
        const data = await response.json();
        const location = data?.results?.[0]?.geometry?.location;
        if (!location) return null;
        return { lat: Number(location.lat), lng: Number(location.lng) };
      } catch (_error) {
        return null;
      }
    }

    async resolvePointCoordinates() {
      if (!this.geocoder || this.pointsResolved) return;
      if (this.pointsResolvingPromise) {
        await this.pointsResolvingPromise;
        return;
      }

      const addressCache = new Map();
      const unresolvedPoints = this.points.filter(
        (point) => !Number.isFinite(point.lat) || !Number.isFinite(point.lng)
      );
      this.pointsResolvingPromise = (async () => {
        for (const point of unresolvedPoints) {
          const address = (point.address || '').trim();
          if (!address) continue;
          if (addressCache.has(address)) {
            const cached = addressCache.get(address);
            point.lat = cached?.lat ?? null;
            point.lng = cached?.lng ?? null;
            continue;
          }

          const resolved = await this.geocodeAddress(address);
          addressCache.set(address, resolved);
          point.lat = resolved?.lat ?? null;
          point.lng = resolved?.lng ?? null;
        }
        this.pointsResolved = true;
      })();

      await this.pointsResolvingPromise;
      this.pointsResolvingPromise = null;
    }

    async initAddressAutocomplete() {
      if (!this.addressMount || !window.google?.maps?.importLibrary) return;

      try {
        const { PlaceAutocompleteElement, AutocompleteSessionToken } = await google.maps.importLibrary('places');
        const inputId = this.addressMount.dataset.inputId || 'StoreLocatorAddress';
        const placeholder =
          this.addressMount.dataset.placeholder || 'Entrez une ville ou un code postal';
        this.autocompleteSessionToken = new AutocompleteSessionToken();

        this.addressAutocomplete = new PlaceAutocompleteElement({
          includedPrimaryTypes: LOCATION_PRIMARY_TYPES,
          requestedLanguage: 'fr',
          placeholder,
          noInputIcon: true,
        });
        this.addressAutocomplete.id = inputId;
        this.addressMount.appendChild(this.addressAutocomplete);
        if (this.localisationIconUrl) {
          const iconPreload = new Image();
          iconPreload.src = this.localisationIconUrl;
        }

        await this.appendClearIconSlot();
        this.customizePlaceAutocompleteElement();
        this.bindAddressAutocompleteEvents();
      } catch (_error) {
        /* Places API non disponible : saisie manuelle + géocodage conservés */
      }
    }

    async appendClearIconSlot() {
      if (!this.addressAutocomplete || !this.closeIconUrl) return;
      if (this.addressAutocomplete.querySelector('[slot="clear-icon"]')) return;

      try {
        const response = await fetch(this.closeIconUrl);
        if (!response.ok) return;

        const clearIconSlot = document.createElement('span');
        clearIconSlot.setAttribute('slot', 'clear-icon');
        clearIconSlot.className = 'store-locator__clear-icon';
        clearIconSlot.setAttribute('aria-hidden', 'true');
        this.clearIconMarkup = await response.text();
        clearIconSlot.innerHTML = this.clearIconMarkup;
        this.addressAutocomplete.appendChild(clearIconSlot);
      } catch (_error) {
        /* icône clear optionnelle */
      }
    }

    customizePlaceAutocompleteElement() {
      const autocomplete = this.addressAutocomplete;
      if (!autocomplete) return;

      const injectShadowStyles = () => {
        const root = autocomplete.shadowRoot;
        if (!root) return;

        let style = root.querySelector('[data-store-locator-chrome]');
        if (!style) {
          style = document.createElement('style');
          style.setAttribute('data-store-locator-chrome', '');
          root.appendChild(style);
        }

        const localisationIconUrl = (this.localisationIconUrl || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'");

        style.textContent = `
          .focus-ring,
          [part="focus-ring"] {
            display: none !important;
            opacity: 0 !important;
            border: none !important;
          }
          .clear-button {
            height: 12px !important;
            width: 12px !important;
            margin-right: 1.5rem !important;
          }
          .clear-button:hover {
            background-color: transparent !important;
          }
          .clear-button:not([hidden]) {
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
            align-items: center !important;
            justify-content: center !important;
          }
          .clear-button > svg {
            display: none !important;
          }
          input::placeholder {
            color: rgb(var(--gray-dark-90)) !important;
            opacity: 1 !important;
          }
          .attributions,
          .dropdown .attributions,
          [part="prediction-list"] .attributions,
          [part="prediction-list"] > :last-child,
          gmp-place-attribution {
            padding: 0 !important;
            padding-top: 0.3125rem !important;
          }
          [part="prediction-list"] [part="prediction-item"]:last-of-type {
            border-bottom: none !important;
          }
          :host {
            overflow: visible !important;
          }

          dialog.full-window-autocomplete-dialog,
          .full-window-autocomplete-dialog {
            display: none !important;
            visibility: hidden !important;
            pointer-events: none !important;
          }

          @media screen and (max-width: 989px) {
            .widget-container {
              position: relative !important;
            }

            .widget-container .input-container,
            .widget-container div:has(> .clear-button) {
              position: relative !important;
            }

            .widget-container .clear-button {
              position: absolute !important;
              top: 50% !important;
              right: 0 !important;
              transform: translateY(-50%) !important;
              margin: 0 !important;
              margin-right: 1.5rem !important;
              height: 12px !important;
              width: 12px !important;
            }

            .widget-container .predictions-anchor,
            .widget-container .dropdown,
            .widget-container [part="prediction-list"] {
              position: absolute !important;
              top: 100% !important;
              left: 0 !important;
              right: 0 !important;
              z-index: 10001 !important;
              margin-top: 0.2rem !important;
            }
          }

          .place-autocomplete-element-row {
            gap: 0.3125rem !important;
          }

          .place-autocomplete-element-text-div {
            display: flex !important;
            align-items: flex-end !important;
            gap: 0.25rem !important;
          }

          .place-autocomplete-element-place-name,
          .place-autocomplete-element-place-result--matched,
          .place-autocomplete-element-place-details {
            font-family: "TWK Lausanne" !important;
            font-size: 12px !important;
            font-style: normal !important;
            font-weight: 400 !important;
            line-height: 140% !important;
            letter-spacing: 0.06px !important;
          }

          .place-autocomplete-element-place-result--matched {
            color: rgb(var(--black-90)) !important;
          }

          .place-autocomplete-element-place-details {
            color: rgb(var(--gray-light-110)) !important;
          }

          [part="prediction-item-icon"] {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 1.125rem !important;
            height: 1.125rem !important;
            flex-shrink: 0 !important;
            background: url('${localisationIconUrl}') no-repeat center / contain !important;
            font-size: 0 !important;
            line-height: 0 !important;
          }

          [part="prediction-item-icon"] > *,
          [part="prediction-item-icon"] svg,
          [part="prediction-item-icon"] img {
            display: none !important;
            visibility: hidden !important;
            width: 0 !important;
            height: 0 !important;
            overflow: hidden !important;
            pointer-events: none !important;
          }

        `;
      };

      const refreshChrome = () => {
        injectShadowStyles();
        this.applyAttributionStyles();
        this.normalizeFullWindowAutocompleteDialogs();
        this.syncClearButtonVisibility();
      };

      refreshChrome();
      this.bindAutocompleteDialogPositioning();

      this.autocompleteChromeObserver?.disconnect();
      this.autocompleteChromeObserver = new MutationObserver(() => {
        refreshChrome();
        this.scheduleEnhancePredictionLabels();
      });
      this.autocompleteChromeObserver.observe(autocomplete, { childList: true, subtree: true });

      this.autocompleteDialogObserver?.disconnect();
      this.autocompleteDialogObserver = new MutationObserver(() => {
        this.normalizeFullWindowAutocompleteDialogs();
      });
      this.autocompleteDialogObserver.observe(document.body, { childList: true, subtree: true });
    }

    getOpenAutocompleteDialogs() {
      const dialogs = [];
      const collect = (root) => {
        if (!root?.querySelectorAll) return;
        root.querySelectorAll('dialog.full-window-autocomplete-dialog[open]').forEach((dialog) => {
          if (!dialogs.includes(dialog)) dialogs.push(dialog);
        });
      };

      collect(this.addressAutocomplete?.shadowRoot);
      collect(document);
      return dialogs;
    }

    restoreInlineAutocompleteWidget() {
      restorePlaceAutocompleteInlineWidget();
      this.syncClearButtonVisibility();
    }

    ensureDialogClearButtonIcons() {
      const root = this.addressAutocomplete?.shadowRoot;
      if (!root || !this.clearIconMarkup) return;

      root
        .querySelectorAll('dialog.full-window-autocomplete-dialog .clear-button, .full-window-autocomplete-dialog .clear-button')
        .forEach((clearButton) => {
          if (clearButton.querySelector('.store-locator__clear-icon')) return;

          const clearIcon = document.createElement('span');
          clearIcon.className = 'store-locator__clear-icon';
          clearIcon.setAttribute('aria-hidden', 'true');
          clearIcon.innerHTML = this.clearIconMarkup;
          clearButton.appendChild(clearIcon);
        });
    }

    normalizeFullWindowAutocompleteDialogs() {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      this.restoreInlineAutocompleteWidget();
    }

    bindAutocompleteDialogPositioning() {
      if (this.autocompleteDialogPositionBound) return;
      this.autocompleteDialogPositionBound = true;

      const reposition = () => this.normalizeFullWindowAutocompleteDialogs();
      window.addEventListener('resize', reposition, { passive: true });
      window.addEventListener('scroll', reposition, { passive: true, capture: true });
      window.visualViewport?.addEventListener('resize', reposition, { passive: true });
      window.visualViewport?.addEventListener('scroll', reposition, { passive: true });
    }

    scheduleAutocompletePredictionSync() {
      window.clearTimeout(this.autocompleteSyncTimer);
      this.autocompleteSyncTimer = window.setTimeout(() => {
        this.syncAutocompletePredictions();
      }, 220);
    }

    scheduleEnhancePredictionLabels() {
      window.clearTimeout(this.autocompleteEnhanceTimer);
      this.autocompleteEnhanceTimer = window.setTimeout(() => {
        this.enhancePredictionLabels();
      }, 60);
    }

    async resetAutocompleteSessionToken() {
      const { AutocompleteSessionToken } = await google.maps.importLibrary('places');
      this.autocompleteSessionToken = new AutocompleteSessionToken();
      this.autocompleteSuggestions = [];
    }

    getPredictionMainText(placePrediction) {
      return String(placePrediction?.mainText?.toString?.() || placePrediction?.mainText?.text || '').trim();
    }

    async getLocationSecondaryLabelForPrediction(placePrediction) {
      const secondary =
        placePrediction?.secondaryText?.toString?.() || placePrediction?.secondaryText?.text || '';
      const parsedSecondary = parseRegionCountryFromSecondaryText(secondary);

      if (parsedSecondary.region && parsedSecondary.country) {
        return formatRegionCountrySecondaryLabel(parsedSecondary.region, parsedSecondary.country);
      }

      const placeId = placePrediction?.placeId;
      if (!placeId) {
        return parsedSecondary.country || extractCountryFromSecondaryText(secondary);
      }

      if (this.countryLabelCache.has(placeId)) {
        return this.countryLabelCache.get(placeId);
      }

      if (this.countryLabelPending.has(placeId)) {
        return this.countryLabelPending.get(placeId);
      }

      const pending = (async () => {
        try {
          const place = placePrediction.toPlace();
          await place.fetchFields({ fields: ['addressComponents'] });
          const components = place.addressComponents || [];
          const admin1 = getAddressComponent(components, 'administrative_area_level_1');
          const admin2 = getAddressComponent(components, 'administrative_area_level_2');
          const country = getAddressComponent(components, 'country');

          const regionLabel =
            getComponentField(admin1, 'long') ||
            getComponentField(admin2, 'long') ||
            parsedSecondary.region;
          const countryLabel =
            getComponentField(country, 'long') ||
            getComponentField(country, 'short') ||
            parsedSecondary.country ||
            extractCountryFromSecondaryText(secondary);

          return formatRegionCountrySecondaryLabel(regionLabel, countryLabel);
        } catch (_error) {
          return (
            formatRegionCountrySecondaryLabel(parsedSecondary.region, parsedSecondary.country) ||
            extractCountryFromSecondaryText(secondary)
          );
        }
      })();

      this.countryLabelPending.set(placeId, pending);
      const result = await pending;
      this.countryLabelPending.delete(placeId);
      this.countryLabelCache.set(placeId, result);
      return result;
    }

    getPredictionSecondaryText(placePrediction) {
      return String(
        placePrediction?.secondaryText?.toString?.() || placePrediction?.secondaryText?.text || ''
      )
        .replace(/\s+/g, ' ')
        .trim();
    }

    getPredictionItemMainText(item) {
      const mainEl = item?.querySelector?.('[part="prediction-item-main-text"]');
      return String(mainEl?.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    getPredictionItemSecondaryText(item) {
      const secondaryEl = item?.querySelector?.('[part="prediction-item-secondary-text"]');
      return String(secondaryEl?.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    findSuggestionForPredictionItem(item, itemIndex, items) {
      const suggestions = this.autocompleteSuggestions || [];
      if (!suggestions.length || !item) return null;

      const cachedPlaceId = item.dataset?.storeLocatorPlaceId;
      if (cachedPlaceId) {
        const cached = suggestions.find(
          (suggestion) => suggestion?.placePrediction?.placeId === cachedPlaceId
        );
        if (cached?.placePrediction) return cached.placePrediction;
      }

      const mainText = this.getPredictionItemMainText(item);
      if (!mainText) return null;

      const predictionAtIndex = suggestions[itemIndex]?.placePrediction;
      if (
        predictionAtIndex &&
        this.getPredictionMainText(predictionAtIndex).replace(/\s+/g, ' ').trim() === mainText
      ) {
        return predictionAtIndex;
      }

      const secondaryText = this.getPredictionItemSecondaryText(item);
      if (secondaryText) {
        const secondaryMatch = suggestions.find((suggestion) => {
          const prediction = suggestion?.placePrediction;
          if (!prediction) return false;
          if (this.getPredictionMainText(prediction).replace(/\s+/g, ' ').trim() !== mainText) {
            return false;
          }
          const predictionSecondary = this.getPredictionSecondaryText(prediction);
          if (predictionSecondary === secondaryText) return true;

          const { region, country } = parseRegionCountryFromSecondaryText(predictionSecondary);
          if (formatRegionCountrySecondaryLabel(region, country) === secondaryText) return true;

          return extractCountryFromSecondaryText(predictionSecondary) === secondaryText;
        });
        if (secondaryMatch?.placePrediction) return secondaryMatch.placePrediction;
      }

      const domItems = items || this.getPredictionItemsInDom();
      const duplicateIndex = domItems
        .slice(0, itemIndex + 1)
        .filter((domItem) => this.getPredictionItemMainText(domItem) === mainText).length - 1;

      const candidates = suggestions
        .map((suggestion) => suggestion?.placePrediction)
        .filter(
          (prediction) =>
            prediction &&
            this.getPredictionMainText(prediction).replace(/\s+/g, ' ').trim() === mainText
        );

      return candidates[duplicateIndex] || null;
    }

    getPredictionItemsInDom() {
      const items = [];
      const root = this.addressAutocomplete?.shadowRoot;
      if (root) {
        root.querySelectorAll('[part="prediction-item"]').forEach((item) => items.push(item));
      }
      document
        .querySelectorAll('dialog.full-window-autocomplete-dialog[open] [part="prediction-item"]')
        .forEach((item) => {
          if (!items.includes(item)) items.push(item);
        });
      return items;
    }

    async syncAutocompletePredictions() {
      const input = this.getAddressValue();
      if (!input || !this.autocompleteSessionToken) {
        this.autocompleteSuggestions = [];
        return;
      }

      this.getPredictionItemsInDom().forEach((item) => {
        delete item.dataset.storeLocatorPlaceId;
      });

      try {
        const { AutocompleteSuggestion } = await google.maps.importLibrary('places');
        const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input,
          includedPrimaryTypes: LOCATION_PRIMARY_TYPES,
          language: 'fr',
          sessionToken: this.autocompleteSessionToken,
        });
        this.autocompleteSuggestions = suggestions || [];
        await this.enhancePredictionLabels();
      } catch (_error) {
        this.autocompleteSuggestions = [];
      }
    }

    async enhancePredictionLabels() {
      const items = this.getPredictionItemsInDom();
      if (!items.length || !this.autocompleteSuggestions?.length) return;

      await Promise.all(
        items.map(async (item, index) => {
          const secondaryEl = item.querySelector('[part="prediction-item-secondary-text"]');
          if (!secondaryEl) return;

          const placePrediction = this.findSuggestionForPredictionItem(item, index, items);
          let secondaryLabel = '';

          if (placePrediction) {
            if (placePrediction.placeId) {
              item.dataset.storeLocatorPlaceId = placePrediction.placeId;
            }
            secondaryLabel = await this.getLocationSecondaryLabelForPrediction(placePrediction);
          }

          if (!secondaryLabel) {
            const parsedSecondary = parseRegionCountryFromSecondaryText(secondaryEl.textContent);
            secondaryLabel =
              formatRegionCountrySecondaryLabel(parsedSecondary.region, parsedSecondary.country) ||
              extractCountryFromSecondaryText(secondaryEl.textContent);
          }

          if (!secondaryLabel || secondaryEl.textContent === secondaryLabel) return;
          secondaryEl.textContent = secondaryLabel;
        })
      );
    }

    applyAttributionStyles() {
      const root = this.addressAutocomplete?.shadowRoot;
      if (!root) return;

      const selectors = [
        '.attributions',
        '.dropdown .attributions',
        '[part="prediction-list"] .attributions',
        '[part="prediction-list"] > :last-child',
        'gmp-place-attribution',
      ];

      selectors.forEach((selector) => {
        root.querySelectorAll(selector).forEach((node) => {
          node.style.setProperty('padding', '0', 'important');
          node.style.setProperty('padding-top', '0.3125rem', 'important');
        });
      });
    }

    bindAddressAutocompleteEvents() {
      const autocomplete = this.addressAutocomplete;
      if (!autocomplete) return;

      autocomplete.addEventListener('gmp-select', (event) => this.onAutocompletePlaceChanged(event));
      autocomplete.addEventListener('input', () => {
        if (!this.suppressAddressInputClearReset) {
          const currentValue = this.getAddressValue();
          if (!currentValue) {
            const recentConfirm = Date.now() - this.lastConfirmedAddressAt < 400;
            if (!recentConfirm) {
              this.confirmedAddressValue = '';
              this.hasCompleteAddress = false;
            }
          } else {
            this.hasCompleteAddress = currentValue === this.confirmedAddressValue;
          }
        }
        this.syncClearButtonVisibility();
        if (!this.getAddressValue()) {
          window.requestAnimationFrame(() => this.syncClearButtonVisibility());
        }
        window.requestAnimationFrame(() => {
          this.applyAttributionStyles();
          this.normalizeFullWindowAutocompleteDialogs();
        });
        this.scheduleAutocompletePredictionSync();
      });
      autocomplete.addEventListener('focus', () => {
        this.addressControl?.classList.add('is-focused');
        window.requestAnimationFrame(() => this.normalizeFullWindowAutocompleteDialogs());
      });
      autocomplete.addEventListener('blur', () => {
        this.addressControl?.classList.remove('is-focused');
        this.syncClearButtonVisibility();
        if (this.skipAddressChangeGeocode) {
          this.skipAddressChangeGeocode = false;
          return;
        }
        this.geocodeUserAddress();
      });
      autocomplete.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.geocodeUserAddress();
        }
      });
      this.syncClearButtonVisibility();
    }

    getAddressValue() {
      const fromProperty = String(this.addressAutocomplete?.value || '').trim();
      if (fromProperty) return fromProperty;

      const shadowInput = this.addressAutocomplete?.shadowRoot?.querySelector(
        '.widget-container input:not(dialog input)'
      );
      return String(shadowInput?.value || '').trim();
    }

    shouldShowAddressClearButton() {
      return this.hasCompleteAddress && !!this.getAddressValue();
    }

    syncClearButtonVisibility() {
      const showClear = this.shouldShowAddressClearButton();
      this.addressControl?.classList.toggle('has-address', showClear);

      const root = this.addressAutocomplete?.shadowRoot;
      const slotClearIcon = this.addressAutocomplete?.querySelector('.store-locator__clear-icon');

      if (slotClearIcon) {
        slotClearIcon.hidden = !showClear;
        slotClearIcon.style.display = showClear ? 'inline-flex' : 'none';
        slotClearIcon.style.visibility = showClear ? 'visible' : 'hidden';
      }

      if (!root) return;

      if (showClear) this.ensureDialogClearButtonIcons();

      const inputPadding = showClear ? '1rem 2.75rem 1rem 1.25rem' : '1rem 1.25rem';
      root.querySelectorAll('input').forEach((input) => {
        input.style.setProperty('padding', inputPadding, 'important');
      });

      root.querySelectorAll('.clear-button').forEach((clearButton) => {
        if (clearButton.closest('dialog.full-window-autocomplete-dialog')) return;

        clearButton.hidden = !showClear;
        clearButton.toggleAttribute('hidden', !showClear);
        clearButton.style.setProperty('display', showClear ? 'flex' : 'none', 'important');
        clearButton.style.setProperty('visibility', showClear ? 'visible' : 'hidden', 'important');
        clearButton.style.setProperty('opacity', showClear ? '1' : '0', 'important');
        clearButton.style.pointerEvents = showClear ? 'auto' : 'none';

        const customClearIcon = clearButton.querySelector('.store-locator__clear-icon');
        if (customClearIcon) {
          customClearIcon.hidden = !showClear;
          customClearIcon.style.display = showClear ? 'inline-flex' : 'none';
          customClearIcon.style.visibility = showClear ? 'visible' : 'hidden';
        }
      });
    }

    getPlaceCoordinates(location) {
      if (!location) return null;
      const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
      const lng = typeof location.lng === 'function' ? location.lng() : location.lng;
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return { lat, lng };
    }

    async onAutocompletePlaceChanged(event) {
      const placePrediction = event?.placePrediction;
      if (!placePrediction) return;

      this.skipAddressChangeGeocode = true;

      const place = placePrediction.toPlace();
      await place.fetchFields({ fields: ['addressComponents', 'location', 'types', 'primaryType'] });

      if (isPreciseAddressResult({ types: [place.primaryType, ...(place.types || [])] })) return;

      const coordinates = this.getPlaceCoordinates(place.location);
      if (!coordinates) return;

      const label = formatLocationLabelFromComponents(place.addressComponents || []);
      if (!label) return;

      this.setAutocompleteLocationValue(label);
      await this.setUserPosition(coordinates, 10);
      await this.resetAutocompleteSessionToken();
    }

    setUserPosition(position, zoom = 10) {
      this.userPosition = position;
      this.activeId = null;
      this.updateUserMarker();
      this.panMapTo(this.userPosition, zoom);
      return this.applyFilters();
    }

    async geocodeUserAddress() {
      const query = this.getAddressValue();
      if (!query) return;
      const requestId = ++this.geocodeRequestId;

      try {
        const resolved = await this.geocodeLocationQuery(query);
        if (requestId !== this.geocodeRequestId) return;

        if (!resolved) {
          this.userPosition = null;
          this.clearUserMarker();
          this.clearMarkers();
          this.renderEmptyList(this.listMessages.noStores);
          this.setStatus('Lieu non trouvé.');
          return;
        }

        if (resolved.label) this.setAutocompleteLocationValue(resolved.label);
        await this.setUserPosition({ lat: resolved.lat, lng: resolved.lng }, 10);
      } catch (_error) {
        this.setStatus('Erreur de géolocalisation.');
      }
    }

    async applyFilters() {
      await this.resolvePointCoordinates();
      const selectedCategory = this.categoryValueInput?.value || '';
      const maxDistance = this.parseDistanceValue(this.distanceValueInput?.value, DEFAULT_DISTANCE_KM);

      if (!this.userPosition) {
        this.clearUserMarker();
        this.clearMarkers();
        this.renderEmptyList(this.listMessages.emptyAddress);
        this.setStatus('');
        return;
      }

      this.filtered = this.points.filter((point) => {
        if (!Number.isFinite(point.lat) || !Number.isFinite(point.lng)) return false;
        if (selectedCategory && point.category !== selectedCategory) return false;
        const d = distanceKm(this.userPosition, { lat: point.lat, lng: point.lng });
        point.distance = d;
        return d <= maxDistance;
      });

      if (!this.filtered.length) {
        this.clearMarkers();
        this.renderEmptyList(this.listMessages.noStores);
        this.focusOnUserPosition(maxDistance);
        this.setStatus('0 point trouvé.');
        return;
      }

      this.renderList(this.filtered);
      this.renderMarkers(this.filtered);
      this.focusOnUserPosition(maxDistance);
      this.setStatus(`${this.filtered.length} point(s) trouvé(s).`);
    }

    renderList(points) {
      if (!this.listNode) return;
      this.listNode.innerHTML = '';
      points.forEach((point) => {
        const pointId = String(point.id);
        const item = document.createElement('div');
        item.className = 'store-locator__item';
        item.dataset.pointId = pointId;
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.innerHTML = `
          <div class="store-locator__item-first-line-wrapper">
            <div class="store-locator__item-title-wrapper">
              <p class="store-locator__item-title">${point.name}</p>
              <p class="store-locator__item-distance">${this.formatDistance(point.distance)}</p>
            </div>
            <p class="store-locator__item-adress">${point.address}</p>
          </div>
          <div class="store-locator__item-meta-wrapper">
            ${this.renderBusinessProfileLink(point.business_profile)}
            <span class="store-locator__item-meta category label" style="${this.getCategoryStyle(point.category_bg, point.category_text)}">${point.category}</span>
          </div>
        `;
        item.addEventListener('click', () => this.selectPoint(pointId, true));
        item.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.selectPoint(pointId, true);
          }
        });

        const businessLink = item.querySelector('.store-locator__business-link');
        if (businessLink) {
          const stopCardSelection = (event) => event.stopPropagation();
          businessLink.addEventListener('click', stopCardSelection);
          businessLink.addEventListener('keydown', stopCardSelection);
        }
        this.listNode.appendChild(item);
      });
      this.listReady = true;
      this.commitReadyState();
    }

    renderEmptyList(message) {
      if (!this.listNode) return;
      this.listNode.innerHTML = `<p class="store-locator__list-message">${this.escapeHtml(message)}</p>`;
      this.listReady = true;
      this.commitReadyState();
    }

    renderMarkers(points) {
      if (!this.map || !this.AdvancedMarkerElement) return;
      this.clearMarkers();
      this.markers = points.map((point) => {
        const pointId = String(point.id);
        const markerElement = document.createElement('button');
        markerElement.type = 'button';
        markerElement.className = 'store-locator__marker';
        const markerPrefix = isEnglishLocale() ? 'Norphé retailer' : 'Point de vente Norphé';
        markerElement.setAttribute('aria-label', `${markerPrefix} : ${point.name || ''}`.trim());

        const marker = new this.AdvancedMarkerElement({
          map: this.map,
          position: { lat: point.lat, lng: point.lng },
          content: markerElement,
          zIndex: MARKER_Z_INDEX.poi,
        });
        markerElement.addEventListener('click', (event) => {
          event.stopPropagation();
          this.selectPoint(pointId, true);
        });
        return { id: pointId, marker, element: markerElement, point };
      });
      this.updateActiveMarkerState();

      if (this.activeId) {
        const activePoint = this.filtered.find((entry) => String(entry.id) === this.activeId);
        if (activePoint) this.showPoiPopup(activePoint);
        else this.hidePoiPopup();
      }
    }

    clearMarkers() {
      this.markers.forEach(({ marker }) => {
        marker.map = null;
      });
      this.markers = [];
      this.hidePoiPopup();
    }

    updateUserMarker() {
      if (!this.map || !this.userPosition || !this.AdvancedMarkerElement) return;
      const position = { lat: this.userPosition.lat, lng: this.userPosition.lng };

      if (this.userMarker) {
        this.userMarker.position = position;
        this.syncMarkerZIndex();
        return;
      }

      const markerWrapper = document.createElement('span');
      markerWrapper.className = 'store-locator__user-marker-wrap';
      markerWrapper.setAttribute('aria-hidden', 'true');

      const markerElement = document.createElement('span');
      markerElement.className = 'store-locator__user-marker';
      markerWrapper.appendChild(markerElement);

      this.userMarkerElement = markerElement;
      this.userMarker = new this.AdvancedMarkerElement({
        map: this.map,
        position,
        content: markerWrapper,
        title: 'Adresse recherchée',
        anchorTop: '-50%',
        anchorLeft: '-50%',
        zIndex: MARKER_Z_INDEX.home,
      });
      this.syncUserMarkerScale();
      this.syncMarkerZIndex();
    }

    syncUserMarkerScale() {
      if (!this.userMarkerElement) return;
      const scale = this.activeId ? USER_MARKER_COMPACT_SCALE : 1;
      this.userMarkerElement.style.transform = scale === 1 ? '' : `scale(${scale})`;
    }

    syncMarkerZIndex() {
      const hasActivePoi = !!this.activeId;

      if (this.userMarker) {
        this.userMarker.zIndex = hasActivePoi ? MARKER_Z_INDEX.homeBehind : MARKER_Z_INDEX.home;
      }

      this.markers.forEach(({ id, marker }) => {
        const isActive = String(id) === this.activeId;
        marker.zIndex = isActive ? MARKER_Z_INDEX.poiActive : MARKER_Z_INDEX.poi;
      });
    }

    clearUserMarker() {
      if (!this.userMarker) return;
      this.userMarker.map = null;
      this.userMarker = null;
      this.userMarkerElement = null;
    }

    fitBounds(points) {
      if (!this.map || !points.length || !window.google?.maps) return;
      const bounds = new google.maps.LatLngBounds();
      if (this.userPosition) bounds.extend(this.userPosition);
      points.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
      this.map.fitBounds(bounds, 60);
      const listener = google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
        if (this.map.getZoom() > 12) this.map.setZoom(12);
      });
      return () => google.maps.event.removeListener(listener);
    }

    focusOnUserPosition(maxDistanceKm = 10, position = this.userPosition) {
      if (!this.map || !position) return;
      const zoomByDistance =
        maxDistanceKm <= 5
          ? 12.4
          : maxDistanceKm <= 10
            ? 11.4
            : maxDistanceKm <= 25
              ? 10.2
              : maxDistanceKm <= 50
                ? 9.2
                : 8.2;
      this.panMapTo(position, zoomByDistance);
    }

    cancelMapFlyAnimation() {
      if (!this.mapFlyAnimationId) return;
      cancelAnimationFrame(this.mapFlyAnimationId);
      this.mapFlyAnimationId = null;
    }

    flyMapTo(position, durationMs = MAP_FLY_DURATION_MS) {
      if (!this.map || !position) return;

      this.cancelMapFlyAnimation();

      const startCenter = this.map.getCenter();
      if (!startCenter) return;

      const startLat = typeof startCenter.lat === 'function' ? startCenter.lat() : startCenter.lat;
      const startLng = typeof startCenter.lng === 'function' ? startCenter.lng() : startCenter.lng;
      const targetLat = position.lat;
      const targetLng = position.lng;
      const startTime = performance.now();
      const easeOutCubic = (t) => 1 - (1 - t) ** 3;

      const tick = (now) => {
        const t = Math.min(1, (now - startTime) / durationMs);
        const eased = easeOutCubic(t);

        if (typeof this.map.moveCamera === 'function') {
          this.map.moveCamera({
            center: {
              lat: startLat + (targetLat - startLat) * eased,
              lng: startLng + (targetLng - startLng) * eased,
            },
          });
        } else {
          this.map.setCenter({
            lat: startLat + (targetLat - startLat) * eased,
            lng: startLng + (targetLng - startLng) * eased,
          });
        }

        if (t < 1) {
          this.mapFlyAnimationId = requestAnimationFrame(tick);
          return;
        }

        this.mapFlyAnimationId = null;
      };

      this.mapFlyAnimationId = requestAnimationFrame(tick);
    }

    panMapTo(position, zoom) {
      if (!this.map || !position) return;
      this.cancelMapFlyAnimation();
      this.map.setCenter(position);
      if (Number.isFinite(zoom)) this.map.setZoom(zoom);
    }

    syncMapViewToUserPosition() {
      if (!this.map || !this.userPosition) return;
      const maxDistance = this.parseDistanceValue(this.distanceValueInput?.value, DEFAULT_DISTANCE_KM);
      this.focusOnUserPosition(maxDistance, this.userPosition);
      this.updateUserMarker();
    }

    scheduleMapViewSync() {
      if (!this.userPosition) return;
      const sync = () => this.syncMapViewToUserPosition();
      sync();
      requestAnimationFrame(() => {
        requestAnimationFrame(sync);
      });
      window.setTimeout(sync, 120);
      window.setTimeout(sync, 320);
    }

    selectPoint(id, flyTo = true) {
      this.activeId = String(id);
      this.listNode?.querySelectorAll('.store-locator__item').forEach((node) => {
        node.classList.toggle('is-active', String(node.dataset.pointId || '') === this.activeId);
      });
      this.updateActiveMarkerState();

      const point = this.filtered.find((p) => String(p.id) === this.activeId);
      if (!point || !this.map) return;

      this.showPoiPopup(point);

      if (!flyTo) return;

      const target = { lat: point.lat, lng: point.lng };
      requestAnimationFrame(() => this.flyMapTo(target));
    }

    buildPoiPopupElement(point) {
      const root = document.createElement('div');
      root.className = 'store-locator__poi-popup-root';

      const popup = document.createElement('div');
      popup.className = 'store-locator__poi-popup';

      if (this.closeIconUrl) {
        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'store-locator__poi-popup-close';
        closeButton.setAttribute('aria-label', 'Fermer');

        const closeIcon = document.createElement('img');
        closeIcon.src = this.closeIconUrl;
        closeIcon.width = 12;
        closeIcon.height = 12;
        closeIcon.alt = '';
        closeButton.appendChild(closeIcon);
        closeButton.addEventListener('click', (event) => {
          event.stopPropagation();
          this.closePoiPopup();
        });
        popup.appendChild(closeButton);
      }

      popup.insertAdjacentHTML(
        'beforeend',
        `
        <p class="store-locator__poi-popup-name">${this.escapeHtml(point.name || '')}</p>
        <p class="store-locator__poi-popup-address">${this.escapeHtml(point.address || '')}</p>
        <div class="store-locator__poi-popup-footer">
          <span class="store-locator__poi-popup-distance">${this.escapeHtml(this.formatDistance(point.distance))}</span>
          <span class="store-locator__poi-popup-category label" style="${this.getCategoryStyle(point.category_bg, point.category_text)}">${this.escapeHtml(point.category || '')}</span>
        </div>
      `
      );

      popup.addEventListener('click', (event) => event.stopPropagation());
      root.appendChild(popup);
      return root;
    }

    closePoiPopup() {
      if (!this.activeId && !this.poiPopupMarker) return;
      this.activeId = null;
      this.hidePoiPopup();
      this.updateActiveMarkerState();
      this.listNode?.querySelectorAll('.store-locator__item').forEach((node) => {
        node.classList.remove('is-active');
      });
    }

    showPoiPopup(point) {
      if (!this.map || !this.AdvancedMarkerElement || !point) return;

      this.hidePoiPopup();

      const position = { lat: point.lat, lng: point.lng };
      this.poiPopupMarker = new this.AdvancedMarkerElement({
        map: this.map,
        position,
        content: this.buildPoiPopupElement(point),
        zIndex: MARKER_Z_INDEX.popup,
      });
    }

    hidePoiPopup() {
      if (!this.poiPopupMarker) return;
      this.poiPopupMarker.map = null;
      this.poiPopupMarker = null;
    }

    updateActiveMarkerState() {
      if (!this.activeId) this.hidePoiPopup();

      this.syncUserMarkerScale();
      this.syncMarkerZIndex();
    }

    setStatus(message) {
      if (this.statusNode) this.statusNode.textContent = message;
    }

    formatDistance(distanceKmValue) {
      if (!Number.isFinite(distanceKmValue)) return '';
      const decimals = distanceKmValue < 10 ? 2 : 1;
      return `${distanceKmValue.toFixed(decimals).replace('.', ',')} km`;
    }

    commitReadyState() {
      if (!this.listReady || !this.mapReady) return;
      this.layoutNode?.classList.add('is-ready');
      if (!this.map) return;

      const scheduleResize = () => {
        try {
          if (window.google?.maps?.event) {
            google.maps.event.trigger(this.map, 'resize');
          }
        } catch (_error) {}
        this.syncMapViewToUserPosition();
      };
      requestAnimationFrame(() => {
        scheduleResize();
        requestAnimationFrame(scheduleResize);
      });
      window.setTimeout(scheduleResize, 120);
      window.setTimeout(scheduleResize, 320);
    }

    setupDropdown({
      triggerSelector,
      listSelector,
      valueInput,
      labelNode,
      onChange,
      isSelectable = () => true,
      keepInitialLabelWhenEmpty = false,
    }) {
      const trigger = this.querySelector(triggerSelector);
      const list = this.querySelector(listSelector);
      const dropdown = trigger?.closest('[data-store-locator-dropdown]');
      if (!trigger || !list || !dropdown || !valueInput) return;
      const initialLabel = labelNode?.textContent?.trim() || '';

      const applySelection = (optionButton, shouldApplyFilters = true, isInitialSelection = false) => {
        if (!isSelectable(optionButton)) {
          this.closeDropdown(dropdown);
          return;
        }
        const value = optionButton.dataset.value ?? '';
        const optionLabel = optionButton.textContent?.trim() || '';
        const label = keepInitialLabelWhenEmpty && isInitialSelection && value === '' ? initialLabel : optionLabel;
        valueInput.value = value;
        labelNode.textContent = label;
        list.querySelectorAll('.store-locator__dropdown-option').forEach((button) => {
          const isSelected = button === optionButton;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
        this.closeDropdown(dropdown);
        if (shouldApplyFilters) onChange();
      };

      const initialButton =
        list.querySelector(`.store-locator__dropdown-option[data-value="${valueInput.value}"]`) ||
        list.querySelector('.store-locator__dropdown-option');
      if (initialButton) applySelection(initialButton, false, true);

      trigger.addEventListener('click', () => {
        const willOpen = !dropdown.classList.contains('is-open');
        this.querySelectorAll('[data-store-locator-dropdown].is-open').forEach((node) => this.closeDropdown(node));
        if (willOpen) {
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          list.hidden = false;
        }
      });

      list.addEventListener('click', (event) => {
        const optionButton = event.target.closest('.store-locator__dropdown-option');
        if (!optionButton || !list.contains(optionButton)) return;
        applySelection(optionButton, true, false);
      });
    }

    closeDropdown(dropdown) {
      const trigger = dropdown.querySelector('.store-locator__dropdown-trigger');
      const menu = dropdown.querySelector('.store-locator__dropdown-menu');
      dropdown.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    }

    escapeHtml(value) {
      return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
    }

    parseDistanceValue(value, fallback = 0) {
      const normalized = String(value ?? '')
        .replace(',', '.')
        .replace(/[^0-9.]/g, '');
      const parsed = Number(normalized);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    }

    renderBusinessProfileLink(rawValue) {
      const href = this.normalizeBusinessProfileUrl(rawValue);
      if (!href) return '';

      const label = isEnglishLocale() ? 'Google Business Profile' : "Fiche d'établissement Google";
      return `<a class="store-locator__business-link" href="${this.escapeHtml(href)}" target="_blank" rel="noopener noreferrer">${label}</a>`;
    }

    normalizeBusinessProfileUrl(rawValue) {
      const value = String(rawValue || '').trim();
      if (!value) return '';

      const candidate = /^https?:\/\//i.test(value) ? value : `https://${value}`;
      try {
        const url = new URL(candidate);
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
        return url.href;
      } catch {
        return '';
      }
    }

    getCategoryStyle(backgroundValue, textValue) {
      const allowed = new Set([
        'white-100',
        'white-105',
        'white-110',
        'gray-dark-90',
        'gray-dark-95',
        'gray-dark-100',
        'gray-light-100',
        'gray-light-105',
        'gray-light-110',
        'black-90',
        'black-95',
        'black-100',
        'signal-green',
        'signal-orange',
        'signal-red',
      ]);
      const bgKey = String(backgroundValue || '').trim();
      const textKey = String(textValue || '').trim();
      const styles = [];
      if (allowed.has(bgKey)) styles.push(`background-color: rgb(var(--${bgKey}));`);
      if (allowed.has(textKey)) styles.push(`color: rgb(var(--${textKey}));`);
      return styles.join(' ');
    }
  }

  if (!customElements.get('store-locator-map')) {
    customElements.define('store-locator-map', StoreLocatorMap);
  }
})();
